import { render, staticRenderFns } from "./LayoutPublicFooter.vue?vue&type=template&id=2e6aec75&scoped=true"
import script from "./LayoutPublicFooter.vue?vue&type=script&lang=js"
export * from "./LayoutPublicFooter.vue?vue&type=script&lang=js"
import style0 from "./LayoutPublicFooter.vue?vue&type=style&index=0&id=2e6aec75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6aec75",
  null
  
)

export default component.exports